import { HashRouter, Route, Routes, useMatch } from "react-router-dom";
import MyRoom from "./MyRoom";
import CardCase from "./CardCase";
import MonitorProject from "./MonitorProject";

const defaultSceneName = 'MyRoom';
const DefaultScene = MyRoom;

const RoutedScene = () => {
  const { params: { name: routeName } } = useMatch('/:name') || { params: { name: defaultSceneName } };
  const sceneName = routeName || 'MyRoom';
  const Scene =
    sceneName === 'MyRoom' ? MyRoom :
    sceneName === 'CardCase' ? CardCase :
    sceneName === 'MonitorProject' ? MonitorProject :
    DefaultScene;
  return <Scene />;
};


export default () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/*" element={<DefaultScene />} />
        <Route path="/:name" element={<RoutedScene />} />
      </Routes>
    </HashRouter>
  );
};
